import React from 'react';
import { LinkButton } from 'fronton-react';
import { useSelector } from 'react-redux';
import { transliterate } from 'utils';
import { createGetExperiment } from 'features/page-model';
import { HIDE_BRANDS_INTERNAL_ID } from 'common/constants';
import {
  pdpC14sDeflistGroupStyle,
  pdpC14sDeflistTermStyle,
  pdpC14sDeflistDefStyle,
} from './pdp-c14s-list.style';

export type PdpC14sLIProps = {
  termKey?: string;
  term?: string;
  definition?: string;
};

export const PdpC14sLI: React.FC<PdpC14sLIProps> = ({ termKey, term, definition }) => {
  const isHideBrandsExperimentActive = !!useSelector(createGetExperiment(HIDE_BRANDS_INTERNAL_ID));

  return (
    <div className={pdpC14sDeflistGroupStyle}>
      <dt className={pdpC14sDeflistTermStyle}>{term}</dt>
      <dd className={pdpC14sDeflistDefStyle}>
        {renderDefinition(isHideBrandsExperimentActive, termKey, definition)}
      </dd>
    </div>
  );
};

export function renderDefinition(isHideBrandsExperimentActive: boolean, key = '', text = '') {
  if (key === 'brand') {
    if (isHideBrandsExperimentActive) {
      return (
        <p className={pdpC14sDeflistDefStyle} data-qa="brand-name-no-link">
          {text}
        </p>
      );
    }
    return (
      <LinkButton target="_blank" href={`/brands/${transliterate(text)}/?brand=${text}`} variant="underline">
        {text}
      </LinkButton>
    );
  } else {
    return text;
  }
}
